import React, {useState} from "react";
import { Screen } from '~common/screen';
import { StyledScreen } from '~common/screen';
import { Styled } from './styled'
import { Accordion, IItem as IIccordionItem } from '~common/accordion'
import { useIsMobile } from "~helpers/hooks/useIsMobile";
import { AmplitudeCounter } from "~/amplitude-counter";

const QualityStandardsScreen = () => {
  const isMobile = useIsMobile();
  const [activeItemIndex, setActiveItemIndex] = useState(0)
  const questions: IIccordionItem[] = [
    {
      title: 'Не знаете как оценить работу менеджера?',
      text: 'АТС оnlinepbx ведет запись разговоров. Прослушка звонков позволит оценить исполнение скрипта и соответствие стандартам (грамотная речь, вежливость и пр.)'
    },
    {
      title: 'Не знаете, что думают о вас клиенты?',
      text: 'Подключите услугу "Оценка качества". После завершения разговора система попросит оценить работу сотрудника от 1 до 5. Звонки с низкой оценкой — первые претенденты на прослушку.'
    },
    {
      title: 'Не понимаете нагрузку сотрудников?',
      text: 'Onlinepbx посчитает нагрузку сотрудников и соберет данные в красивый отчет. Количество звонков, длительность разговоров, оценка качества — вы получите все данные для принятия обоснованных решений.'
    }
  ]

  const iconsDictionary = [
    <img src={process.env.PUBLIC_DIR + '/images/index_page/quality_standarts/icon_1.svg'} />,
    <img src={process.env.PUBLIC_DIR + '/images/index_page/quality_standarts/icon_2.svg'} />,
    <img src={process.env.PUBLIC_DIR + '/images/index_page/quality_standarts/icon_3.svg'} />
  ]
  const colorsDictionary = ['#d4d3ff', '#ffddb6', '#f7d5f0']

  return (
    <Screen
      title={!isMobile && <span>Внедрите <StyledScreen.GreenText>стандарты</StyledScreen.GreenText> качества</span> || null}
    >
      <Styled.Container>
        <Styled.Left>
          <Styled.IconWrapp>
            <Styled.IconBg color={colorsDictionary[activeItemIndex]}>
              <Styled.IconPlace>
                {iconsDictionary[activeItemIndex]}
              </Styled.IconPlace>
            </Styled.IconBg>
          </Styled.IconWrapp>
        </Styled.Left>
        <Styled.Right>
          <Accordion
            data={questions}
            initialElemIndex={0}
            onChange={(index: number, item: IIccordionItem) => {
              setActiveItemIndex(index)
              AmplitudeCounter('click_open_question', { question: item.title })
            }}
          />
        </Styled.Right>
      </Styled.Container>
    </Screen>
  )
}

export { QualityStandardsScreen }